import type React from 'react'
import styled from 'styled-components'

import type { RentDeduction } from '@/types/Landlord'
import { Colours } from '@/utils/styles'

interface Props {
  status: RentDeduction
}

const Container = styled.div``

const DeductionIndictator = styled.div<{ status: RentDeduction }>`
  margin: 20px 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex: 1 1 auto;
  background: rgba(188, 190, 192, 0.2);
  border-radius: 10px;
  font-weight: bold;
  padding: 5px;
  div {
    height: 40px;
    border-radius: 10px;
    display: inline-flex;
    flex: 1 1 auto;
    justify-content: center;
    color: #082842;
    align-items: center;
  }

  #not-sure {
    color: ${props => (props.status === 'Uncertain' ? '#fff' : '')};
    background-color: ${props => (props.status === 'Uncertain' ? Colours.blue : '')};
  }
  #none {
    color: ${props => (props.status === 'None' ? '#fff' : '')};
    background-color: ${props => (props.status === 'None' ? Colours.teal : '')};
  }
  #minor {
    color: ${props => (props.status === 'Minor' ? '#fff' : '')};
    background-color: ${props => (props.status === 'Minor' ? '#ED941E' : '')};
  }
  #major {
    color: ${props => (props.status === 'Major' ? '#fff' : '')};
    background-color: ${props => (props.status === 'Major' ? 'red' : '')};
  }
`

const LandlordRentDeductions: React.FC<Props> = ({ status }) => {
  return (
    <Container>
      <h4>Damages & Rent Deductions</h4>
      <DeductionIndictator status={status}>
        <div id="not-sure">Unsure</div>
        <div id="none">None</div>
        <div id="minor">Minor</div>
        <div id="major">Major</div>
      </DeductionIndictator>
    </Container>
  )
}

export default LandlordRentDeductions
